(ns rothko.form2.validation-message.component
  (:require [rothko.form2.component :as form]
            [rothko.form2.validation :as validation]))

(defn message
  [message]
  ;; TODO rothko#229 validation class should come from appearances
  [:small.form__validation-message.error
   message])

(defn component
  [{:keys [::validation/current-messages ::form/dirty? ::form/name]
    :as field-props}]
  (cond-> [:div.form__validation-messages]
    dirty? (into (map message current-messages))))
